import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { Divider } from '@mui/material';
import { $canWriteInTicketResidentChat } from '@features/common';
import { clearSelectedMessages } from '../../models';
import { $activeChatTab } from '../../models/chat-tabs';
import { ChatPanel } from '../../organisms/chat-panel';
import { ChatTabsComponentTypes, chatTabsTypes } from '../../types/chat-tabs';
import { ChatTabs } from '../chat-tabs';
import { ChatHeader } from '../chat/chat-header';
import * as Styled from './styled';

export const ChatWithTabs = ({
  mainChatId,
  technicalSupportChatId,
  standalone,
  hideLeaveButton,
  readonly,
  token,
  hideTabs = false,
}: ChatTabsComponentTypes) => {
  const [activeChatTab, canWriteInTicketResidentChat] = useUnit([
    $activeChatTab,
    $canWriteInTicketResidentChat,
  ]);

  const showEmployeesOrApplicantChat =
    activeChatTab === chatTabsTypes.employees ||
    activeChatTab === chatTabsTypes.applicant;

  useEffect(() => {
    clearSelectedMessages();
  }, [activeChatTab]);

  return (
    <Styled.Panel standalone={!!standalone}>
      <ChatHeader
        hideLeaveButton={!!hideLeaveButton}
        noNeedChooseMessages={!!technicalSupportChatId}
      />

      {!hideTabs && (
        <ChatTabs
          mainChatId={mainChatId}
          technicalSupportChatId={technicalSupportChatId}
        />
      )}

      <Divider />

      {showEmployeesOrApplicantChat && (
        <ChatPanel
          channelId={mainChatId}
          readonly={readonly}
          token={token}
          activeChatTab={activeChatTab}
          canWriteInTicketResidentChat={canWriteInTicketResidentChat}
        />
      )}

      {technicalSupportChatId && activeChatTab === chatTabsTypes.technicalSupport && (
        <ChatPanel
          activeChatTab={activeChatTab}
          channelId={technicalSupportChatId}
          readonly={readonly}
          token={token}
        />
      )}
    </Styled.Panel>
  );
};
